<div class="table-responsive">
  <div class="card">
    <div class="card-body">

      <div class="row">
        <div class="col-md-12">
          <div class="d-flex align-items-center justify-content-between mt-3 mb-3" style="padding-left: 1%;">
            <h2 style="margin-bottom: 0;">Projects Template</h2>
            <div class="button-items d-flex align-items-center" style="gap: 8px;">
              <button class="btn btn-primary btn-sm m-1" (click)="newTemplate()" pTooltip="Add a new project template" appActionTooltip>Add Template
                @if (tpltLoading) {
                  <i style="margin-left: 7px;" class="fa fa-solid fa-sync fa-spin"></i>
                }
              </button>
              <button class="btn btn-primary btn-sm m-1" (click)="loadTemplateData(lastTableLazyLoadEvent)"
                pTooltip="Refresh Table" appActionTooltip><i class="mdi mdi-reload"></i></button>
                <button class="btn btn-primary btn-sm m-1" (click)="dt.clear()" pTooltip="Clear Filters" appActionTooltip>Clear
                  <i class="mdi mdi-filter-remove"></i></button>
                </div>
              </div>
            </div>
          </div>
          <p-table [lazy]="true" (onLazyLoad)="loadTemplateData($event)"
            [value]="allTemplates"[rowHover]="true" [rows]="10"
            [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]" [loading]="loading"
            responsiveLayout="scroll" [paginator]="true" [autoLayout]="true" [totalRecords]="totalRecords"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [filterDelay]="0" paginatorDropdownAppendTo="body" #dt>
            <ng-template pTemplate="header" let-columns >
              <tr>
                <th >
                  <div class="flex justify-content-between align-items-center">
                    Actions
                  </div>
                </th>
                <th pSortableColumn="description">
                  <div class="flex justify-content-between align-items-center">
                    Template Name
                    <div >
                      <p-sortIcon field="description"></p-sortIcon>
                      <p-columnFilter matchMode="contains"  [showOperator]="false" [showAddButton]="false"
                        [matchModeOptions]="matchModeOptionsString" type="text" field="description"
                      display="menu" ></p-columnFilter>
                    </div>
                  </div>
                </th>
                <th pSortableColumn="practiceArea">
                  <div class="flex justify-content-between align-items-center">
                    Practice Area
                    <div >
                      <p-sortIcon field="practiceArea"></p-sortIcon>
                      <p-columnFilter matchMode="contains"  [showOperator]="false" [showAddButton]="false"
                        [matchModeOptions]="matchModeOptionsString" type="text" field="practiceArea"
                      display="menu" ></p-columnFilter>
                    </div>
                  </div>
                </th>
                <th pSortableColumn="status">
                  <div class="flex justify-content-between align-items-center">
                    Status
                    <div >
                      <p-sortIcon field="status"></p-sortIcon>
                      <p-columnFilter matchMode="contains"  [showOperator]="false" matchMode="equals" [showAddButton]="false"
                        [matchModeOptions]="matchModeOptionsString"  field="status"
                        display="menu" >
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                          <p-dropdown [ngModel]="value" [options]="statusList"
                            (onChange)="filter($event.value)" placeholder="Any">
                            <ng-template let-option pTemplate="item">
                              <span
                              [class]="'customer-badge descriptionType-' + option.value">{{option.label}}</span>
                            </ng-template>
                          </p-dropdown>
                        </ng-template></p-columnFilter>
                      </div>
                    </div>
                  </th>

                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-template>
                <tr>
                  <td  width="150">
                    <div class="flex justify-content-between align-items-center">
                                <button pTooltip="View Template" appActionTooltip class="btn btn-info btn-sm" (click)="viewTemplate(template)" role="button"><i class="
                            mdi mdi-eye"></i></button>
                      <span appActionTooltip [pTooltip]="template.projectTemplate.status!='Active' ? 'Only Active templates can be edited' : 'Edit Template'" [actionDisabled]="template.projectTemplate.status!='Active'"><button class="btn btn-warning btn-sm" [disabled]="template.projectTemplate.status!='Active'" (click)="editTemplate(template)" role="button"><i
                      class="mdi mdi-pencil"></i></button></span>
                      <span appActionTooltip [pTooltip]="template.projectTemplate.status!='Active' ? 'Only Active templates can have tasks assigned' : 'Assign Task to Template'" [actionDisabled]="template.projectTemplate.status!='Active'"><button class="btn btn-success btn-sm" [disabled]="template.projectTemplate.status!='Active'" (click)="openTaskAssignment(template)" role="button"><i
                      class="mdi mdi-account-plus"></i></button></span>
                      <button class="btn btn-danger btn-sm" pTooltip="Activate / Inactivate Template" appActionTooltip  (click)="addTemplate(template,true)"
                        role="button"><i class="mdi mdi-block-helper"></i></button>
                      </div>
                    </td>
                    <td>
                      {{template.projectTemplate.description}}
                    </td>
                    <td>
                      {{template.projectTemplate.practiceArea}}
                    </td>
                    <td>
                      {{template.projectTemplate.status}}
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td [attr.colspan]="4">
                      No records found
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>

        <p-dialog [resizable]="false" [draggable]="false" [(visible)]="templateDialogue" (onHide)="closeDialogue()" [style]="{width: '80%'}" [header]="title" [modal]="true" styleClass="p-fluid">

          <ng-template pTemplate="content">
            <div class="card">
              <div class="card-body">
                @if (!viewOnly) {
                  <div class="row" style="margin-bottom:2%;">
                    <div class="col-sm-4" style="display: inline-flex;">
                      <label for="assignTask" class="form-label" style="width: 11%;margin-top: 1%;" >Task:</label>
                      <select id="assignTask" class="form-select"  [(ngModel)]="newTask" >
                        <option  ngValue="Select">Select</option>
                        @for (value of selectedTemplate.unassignedTasks; track value) {
                          <option [disabled]="value.disabled" [ngValue]="value" [title]="value.qbDescription">{{value.taskName}}
                          </option>
                        }
                      </select>
                    </div>
                    @if (!viewOnly) {
                      <div class="col-sm-6">
                        <button class="btn btn-primary btn-sm" (click)="addTemplateTask()" pTooltip="Assign the selected task to this template" appActionTooltip
                        style="margin-top: 1%;">Assign Task</button>
                        @if (assignLoading) {
                          <i style="margin-left: 7px;" class="fa fa-solid fa-sync fa-spin"></i>
                        }
                      </div>
                    }
                  </div>
                }

                <p-table [(value)]="selectedTemplate.tasks" [rowHover]="true"
                  [scrollable]="true" scrollHeight="300px" >
                  <ng-template pTemplate="header">
                    <tr>
                      <th >Task Name</th>
                      <th >Task Full Name</th>
                      <th >Task Type</th>
                      <th >Practice Area</th>
                      <th >Description</th>
                      <th >Rate</th>
                      <th >Rate Type Code</th>
                      @if (!viewOnly) {
                        <th style="width:6rem">Delete</th>
                      }
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-task>
                    <tr>
                      <td>{{task.taskName}}</td>
                      <td>{{task.taskFullName}}</td>
                      <td>{{task.taskTypeCode}}</td>
                      <td>{{task.practiceAreaCode}}</td>
                      <td>{{task.description}}</td>
                      <td>{{task.rate}}</td>
                      <td>{{task.rateTypeCode}}</td>
                      @if (!viewOnly) {
                        <td style="width:6rem">
                          <div  class="flex justify-content-between align-items-center">
                            <a class="btn btn-warning btn-sm" (click)="deleteTask(task)" pTooltip="Remove this task from the template" appActionTooltip role="button"><i
                            class="mdi mdi-trash-can"  width="44" height="44"></i></a>
                          </div>
                        </td>
                      }
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                      <td [attr.colspan]="columns && columns.length">
                        No records found
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </ng-template>
        </p-dialog>

        <p-dialog [resizable]="false" [draggable]="false" [(visible)]="editDialogue" (onHide)="closeDialogue()" [style]="{width: '60%'}" [header]="title" [modal]="true" styleClass="p-fluid">

          <ng-template pTemplate="content">
            <div class="card">
              <div class="card-body">
                <div class="row"  style="margin-bottom:2%;">
                  <div class="col-sm-6">
                    <div>
                      <label for="projectTemplate" class="form-label">Project Template:</label>
                      <input class="form-control" type="text" [(ngModel)]="selectedTemplate.projectTemplate.description" id="projectTemplate" appSpellCheck>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div>
                      <label for="projectTemplate" class="form-label">Practice Area</label>
                      <p-dropdown  appendTo="body" defaultLabel="Select Practice Area" [(ngModel)]="selectedTemplate.projectTemplate.practiceArea" [options]="tkAreas" optionLabel="description" optionValue="description"></p-dropdown>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div style="margin-top: 7%;">
                      <button class="btn btn-primary btn-sm" (click)="addTemplate()" pTooltip="Save changes to this template" appActionTooltip>Update Template</button>
                      @if (assignLoading) {
                        <i style="margin-left: 7px;" class="fa fa-solid fa-sync fa-spin"></i>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </p-dialog>
        <p-dialog [resizable]="false" [draggable]="false" [(visible)]="newTempDialogue" (onHide)="closeDialogue()" [style]="{width: '60%'}" [header]="title" [modal]="true" styleClass="p-fluid">

          <ng-template pTemplate="content">
            <div class="card">
              <div class="card-body">
                <div class="row"  style="margin-bottom:2%;">
                  <div class="col-sm-6">
                    <div>
                      <label for="projectTemplate" class="form-label">Project Template</label>
                      <input class="form-control" type="text" [(ngModel)]="projectTemplateName" id="projectTemplate" appSpellCheck>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div>
                      <label for="projectTemplate" class="form-label">Practice Area</label>
                      <!-- <p-multiSelect [maxSelectedLabels]="10000"  appendTo="body" defaultLabel="Select Practice Area" [(ngModel)]="tkPracticeArea" [options]="tkAreas" optionLabel="description" optionValue="description"></p-multiSelect> -->
                      <p-dropdown appendTo="body" [options]="tkAreas" [(ngModel)]="practiceArea" optionLabel="description" placeholder="Select Practice Area"></p-dropdown>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div style="margin-top: 7%;">
                      <button class="btn btn-primary btn-sm" (click)="addNewTemplate()" pTooltip="Create the new template" appActionTooltip>Add Template</button>
                      @if (assignLoading) {
                        <i style="margin-left: 7px;" class="fa fa-solid fa-sync fa-spin"></i>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </p-dialog>